/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from '@shared/services';

@Component({
  selector: 'app-library-clip-filtering-modal',
  templateUrl: './library-clip-filtering-modal.component.html',
  styleUrls: ['./library-clip-filtering-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibraryClipFilteringModalComponent implements OnInit {
  @Input() title = 'Filter clips';
  @Input() subtitle = 'Select from event or game';
  @Input() videos;
  @Input() dropdownData;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  selectedEventId = 0;
  selectedGameId = 0;
  selectedAthleteId = 0;
  dropdownEvents = [];
  dropdownGames = [];
  dropdownAthletes = [];

  constructor(private utilsService: UtilsService) {}

  ngOnInit() {
    if (this.dropdownData.event) {
      this.selectedEventId = this.dropdownData.event.selected;
      this.dropdownEvents = [...this.dropdownData.event.options];
    }
    if (this.dropdownData.game) {
      this.selectedGameId = this.dropdownData.game.selected;
      this.dropdownGames = this.dropdownData.game.options;
    }
    if (this.dropdownData.athlete) {
      this.selectedAthleteId = this.dropdownData.athlete.selected;
      this.dropdownAthletes = this.dropdownData.athlete.options;
    }
  }

  ngOnChanges() {}

  changeEvent(selectedEvent) {
    if (this.selectedEventId || this.selectedEventId === 0) {
      this.selectedGameId = 0;
    }
    if (this.dropdownData.game) {
      this.setDropdownValues();
    }
  }

  changeGame(selectedGame) {
    if (!this.selectedGameId) {
      this.changeEvent(this.selectedEventId);
    }
  }

  applyFilters() {
    const applyFiltersMsg = {
      confirm: true,
      dropdownData: {
        event: {
          selected: this.selectedEventId,
          options: this.dropdownEvents,
        },
        game: {
          selected: this.selectedGameId,
          options: !this.selectedGameId ? [] : this.dropdownGames,
        },
        athlete: {
          selected: this.selectedAthleteId,
          options: !this.selectedAthleteId ? [] : this.dropdownAthletes,
        },
      },
    };

    this.closeModal.emit(applyFiltersMsg);
  }

  close() {
    this.closeModal.emit({ confirm: false });
  }

  trackByFn(item) {
    return item ? item.value : null;
  }

  private setDropdownValues() {
    this.dropdownGames = [{ name: 'All games', value: 0 }];

    if (!this.dropdownEvents.length) {
      this.videos.forEach((video) => {
        let existingEvent;
        if (video.event) {
          existingEvent = this.dropdownEvents.find((de) => de.value === video.event.id);
          if (!existingEvent) {
            this.dropdownEvents = [...this.dropdownEvents, { name: video.event.name, value: video.event.id }];
          }
        }
      });
      this.dropdownEvents = [
        { name: 'All events', value: 0 },
        ...this.dropdownEvents.sort(this.utilsService.sortStringByProp),
      ];
    }

    this.videos.forEach((video) => {
      let existingEvent;
      if (video.event) {
        existingEvent = this.dropdownEvents.find((de) => de.value === video.event.id);
      }
      if (video.game) {
        if (existingEvent) {
          if (!existingEvent.games) {
            existingEvent.games = [{ name: video.game.name, value: video.game.id }];
          } else {
            const gameExists = existingEvent.games.find((dg) => dg.value === video.game.id);
            if (!gameExists) {
              existingEvent.games.push({ name: video.game.name, value: video.game.id });
            }
          }
        }
      }
    });
    if (this.selectedEventId) {
      const selectedEvent = this.dropdownEvents.find((de) => de.value === this.selectedEventId);
      if (selectedEvent && selectedEvent.games) {
        this.dropdownGames = [
          ...this.dropdownGames.sort(this.utilsService.sortStringByProp),
          ...selectedEvent.games.sort(this.utilsService.sortStringByProp),
        ];
      }
    } else if (this.dropdownData && this.dropdownData.game && this.dropdownData.game.options) {
      this.dropdownGames = [
        ...this.dropdownGames.sort(this.utilsService.sortStringByProp),
        ...this.dropdownData.game.options.sort(this.utilsService.sortStringByProp),
      ];
    }
  }
}
